import { preloadViewsQuery } from "@/entities/view/api/fetch-views-and-columns-query";
import { ContentType } from "@/shared/gql/graphql";

export const preloadTenderOverviewQueries = (companyId: string) => {
  preloadViewsQuery({
    companyId,
    contentType: ContentType.Tender,
  });
};
